export default "e0ae810ccc0bc7aa.svg"